var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"root-layout",class:_vm.rootLayoutClass},[(_vm.showAsideMenu)?_c('AsideIconMenu'):_vm._e(),_c('LightHeader'),_c('div',{staticClass:"main-content"},[_vm._t("default",function(){return [_c('router-view')]})],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }